import { useSafeAreaInsets } from "react-native-safe-area-context";

const STATUS_BAR_GAP = 12;

// Top padding that pushes header content below the status bar / notch. RN's
// built-in SafeAreaView is a no-op on Android, so screens must use the inset.
// Sitting flush under the status bar still left the menu hard to tap (taps
// near the top open the system shade instead), so add breathing room on
// devices that have a status-bar inset (#128). Web has no inset — unchanged.
// Shared by the app header and the full-screen mobile menu so the logo and
// menu/close button sit in the same spot on both (#117).
export default function useHeaderTopPadding(): number {
  const insets = useSafeAreaInsets();
  return insets.top > 0 ? insets.top + STATUS_BAR_GAP : insets.top;
}
